@use '@/styles/tokens' as *;

.layout {
  display: flex;
  min-height: 100vh;
}

.brand {
  flex: 0 0 63%; // 14/24 split on desktop, mirrors the prior Col span
  position: relative;
  background-size: cover;
  // background-position: 25% 75%;
  padding: 48px 62px 128px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  // Brand panel is desktop-only; below lg the form panel takes the full width.
  @include down(lg) {
    display: none;
  }
}

.logo {
  width: 60px;
}

.panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
}

.outlet {
  flex: 1;
  display: grid;
  place-items: center;
  width: 100%;
  position: relative;
}

.footer {
  font-size: 12px;
  color: $color-neutral-700;
  padding-bottom: 24px;
}

.card {
  width: 100%;
  max-width: 400px;
  animation: rise 320ms ease both;
}

.cardHeader {
  margin-bottom: 24px;
  text-align: center;
}

.cardHeader h1 {
  font-size: 32px;
  font-family: $font-family-heading;
  $font-weight-regular: 400;
  margin: 0 0 8px;
}

.cardHeader p {
  color: $color-neutral-800;
  margin: 0;
  font-size: $font-size-xs;
}

.bgPattern {
  position: absolute;
  top: -5%;
  left: 5%;
  object-fit: cover;
  opacity: 0.5;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    animation: none;
  }
}
